import { NgModule, Pipe, PipeTransform } from "@angular/core";

/**
 * Checks if the object has at least one key.
 * @param value - The object to evaluate.
 * @returns `true` if the object is not null and has keys, otherwise `false`.
 */

@Pipe({
    name: "hasKeys",
    standalone: false
})
export class HasKeysPipe implements PipeTransform {
  transform(value: object | null | undefined): boolean {
    return value && Object.keys(value).length > 0;
  }
}

@NgModule({
  declarations: [HasKeysPipe],
  exports: [HasKeysPipe],
})
export class HasKeysPipeModule {}
